// @flow

import { retrieve } from 'putki';

function addUrlFragment(url, fragment) {
  if (url.includes('?')) {
    return `${url}&${fragment}`;
  } else {
    return `${url}?${fragment}`;
  }
}

export function withAuthTokenIfExists(url: string): string {
  const authToken = retrieve('auth_token');
  if (typeof authToken !== 'string') {
    return url;
  }

  return addUrlFragment(url, `auth=${authToken}`);
}
